import ErrorPage from './errorPage';
import {
  BrowserRouter as Router, Routes, Route, Navigate
} from "react-router-dom";
import PmsUrlConfig from '../urlConfig';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState, useCallback } from 'react';
import { getToken, getUser, getServiceTypes, getPracticeDetails } from '../utils/storageUtils';
import { getMatrixClient, getMatrixServer } from './matrix/matrixFuntions';
import store from '../redux/store.js';

import pmsConstants from '../pmsConstants';
import LandingPage from './LandingPage/LandingPage';
import SignupPage from './SignUpPage/SignupPage';
import UserManagement from './UserManagement/UserManagementPage';
import ServiceLocations from './ServiceLocationManagement/ServiceLocations';
import SettingsPage from './SettingsPage/SettingsPage';
import StaffAppointmentsPage from './AppointmentsPage/StaffAppointmentsPage';
import PatientAppointmentsPage from './AppointmentsPage/PatientAppointmentsPage';
import StaffChatsPage from './ChatsPage/StaffChatsPage';
import PatientDashboardPage from './Dashboard/PatientDashboardPage';
import PatientChatsPage from './ChatsPage/PatientChatPage';
import ForgotPasswordPage from './ForgotPasswordPage/ForgotPassword';
import VerifyCode from './ForgotPasswordPage/VerifyCode';
import ChangePassword from './ForgotPasswordPage/ChangePassword';
import HealthCheck from './HealthCheck';

export default function Main() {
  const loginDetails = useSelector(state => state.loginDetails);
  const dispatch = useDispatch();

  // Hydration state to avoid redirecting before we restore session
  const [hydrated, setHydrated] = useState(false);

  // Initialize session from localStorage on app startup
  const initializeSession = useCallback(async () => {
    const token = getToken();
    const user = getUser();
    const serviceTypes = getServiceTypes();
    const practice = getPracticeDetails();

    if (token && user) {
      console.log('Restoring session from localStorage');
      console.log('User object being restored:', user);
      console.log('Practice object being restored:', practice);
      dispatch({
        type: 'hydrateFromStorage',
        payload: {
          isLoggedIn: true,
          jwtToken: token,
          loggedInUser: user,
          serviceTypes: serviceTypes,
        }
      });
      if (practice) {
        dispatch({
          type: 'practiceLoginSuccess',
          payload: practice
        });
      }
    } else {
      console.log('No saved session found in localStorage');
    }

    setHydrated(true);
    console.log('Hydration complete');
    
    // Reinitialize Matrix client if user is logged in
    if (token && user && user.access_token && user.synapse_user_id) {
      console.log('Reinitializing Matrix client from stored user data');
      try {
        const matrixClient = getMatrixClient(user.access_token, user.synapse_user_id);
        const matrixServer = getMatrixServer(user.access_token, user.synapse_user_id);
        
        // Start the Matrix client and wait for it to sync before dispatching
        await matrixClient.startClient({ initialSyncLimit: 1000, lazyLoadMembers: true });
        
        // Wait for client to be ready
        matrixClient.once("sync", function (state, prevState, res) {
          if (state === "PREPARED") {
            console.log('Matrix client prepared and ready');
            dispatch({
              type: 'setMatrixClient',
              payload: matrixClient
            });
            
            dispatch({
              type: 'setMatrixServer',
              payload: matrixServer
            });
            
            console.log('Matrix client reinitialized successfully');
          } else {
            console.log('Matrix client sync state:', state);
          }
        });
      } catch (error) {
        console.error('Failed to reinitialize Matrix client:', error);
      }
    }
  }, [dispatch]);

  useEffect(() => {
    initializeSession();
  }, [dispatch, initializeSession]);

  // Cleanup Matrix client when component unmounts
  useEffect(() => {
    return () => {
      console.log('MainComponent unmounting - cleaning up Matrix client');
      const state = store.getState();
      const matrixClient = state.chatDetails?.matrixClient;
      
      if (matrixClient) {
        try {
          // Add guard to prevent multiple stops
          if (!matrixClient._isStopped && matrixClient.stopClient && typeof matrixClient.stopClient === 'function') {
            matrixClient.stopClient();
            matrixClient._isStopped = true; // Mark as stopped
            console.log('Matrix client stopped on component unmount');
          }
          
          // Remove all event listeners (idempotent)
          if (matrixClient.removeAllListeners && typeof matrixClient.removeAllListeners === 'function') {
            matrixClient.removeAllListeners();
            console.log('Matrix client listeners removed on component unmount');
          }
        } catch (error) {
          console.warn('Error stopping Matrix client on unmount:', error);
        }
      }
    };
  }, []);

  var loggedInUser = null;
  var userType = '';
  if (loginDetails != null) {
    loggedInUser = loginDetails.loggedInUser;
  }
  if (loggedInUser != null) {
    userType = loggedInUser.user_type;
  }
  const isLoggedIn = loginDetails.isLoggedIn;

  const hasJWT = !!loginDetails.jwtToken;

  console.log('Route check - hydrated:', hydrated, 'isLoggedIn:', isLoggedIn, 'hasJWT:', hasJWT, 'jwtToken:', loginDetails.jwtToken ? 'exists' : 'missing');
  console.log('loggedInUser from Redux:', loggedInUser);
  
  if (!hydrated) {
    return <div>Loading...</div>;
  }

  return (

    <Router basename="/">
      <Routes>
        <Route
          exact
          path={PmsUrlConfig.HOME_URL}
          element={(hydrated && isLoggedIn && hasJWT) ? userType === pmsConstants.USER_TYPE_PRACTICE_STRING ? <Navigate replace to={PmsUrlConfig.WELCOME_URL} /> :
            userType === pmsConstants.USER_TYPE_STAFF ? <Navigate replace to={PmsUrlConfig.APPOINTMENTS} /> :
              <Navigate replace to={PmsUrlConfig.WELCOME_URL} />
            : <div className="col-12 main-div"><LandingPage /></div>}
          errorElement={<ErrorPage />}
        />

        <Route
          exact
          path={PmsUrlConfig.SIGN_UP_URL}
          element={(hydrated && isLoggedIn && hasJWT) ? userType === pmsConstants.USER_TYPE_PRACTICE_STRING ? <Navigate replace to={PmsUrlConfig.WELCOME_URL} /> :
            userType === pmsConstants.USER_TYPE_STAFF ? <Navigate replace to={PmsUrlConfig.APPOINTMENTS} /> :
              <Navigate replace to={PmsUrlConfig.WELCOME_URL} />
            : <div className="col-12 main-div"><SignupPage /></div>}
          errorElement={<ErrorPage />}
        />
        <Route
          exact
          path={PmsUrlConfig.SIGN_UP_CONFIMATION_URL}
          element={(hydrated && isLoggedIn && hasJWT) ? userType === pmsConstants.USER_TYPE_PRACTICE_STRING ? <Navigate replace to={PmsUrlConfig.WELCOME_URL} /> :
            userType === pmsConstants.USER_TYPE_STAFF ? <Navigate replace to={PmsUrlConfig.APPOINTMENTS} /> :
              <Navigate replace to={PmsUrlConfig.WELCOME_URL} />
            : <div className="col-12 main-div"><LandingPage /></div>}
          errorElement={<ErrorPage />}
        />
        <Route
          exact
          path={PmsUrlConfig.LOGIN_URL}
          element={(hydrated && isLoggedIn && hasJWT) ? userType === pmsConstants.USER_TYPE_PRACTICE_STRING ? <Navigate replace to={PmsUrlConfig.WELCOME_URL} /> :
            userType === pmsConstants.USER_TYPE_STAFF ? <Navigate replace to={PmsUrlConfig.APPOINTMENTS} /> :
              <Navigate replace to={PmsUrlConfig.WELCOME_URL} />
            : <div className="col-12 main-div"><LandingPage /></div>}
          errorElement={<ErrorPage />}
        />
        <Route
          exact
          path={PmsUrlConfig.HEALTH_CHECK_URL}
          element={<HealthCheck />}
        />
        <Route
          exact
          path={PmsUrlConfig.FORGOT_PASSWORD_URL}
          element={(hydrated && isLoggedIn && hasJWT) ? userType === pmsConstants.USER_TYPE_PRACTICE_STRING ? <Navigate replace to={PmsUrlConfig.WELCOME_URL} /> :
            userType === pmsConstants.USER_TYPE_STAFF ? <Navigate replace to={PmsUrlConfig.APPOINTMENTS} /> :
              <Navigate replace to={PmsUrlConfig.WELCOME_URL} />
            : <div className="col-12 main-div"><ForgotPasswordPage /></div>}
          errorElement={<ErrorPage />}
        />
        <Route
          exact
          path={PmsUrlConfig.VERIFY_CODE_URL}
          element={(hydrated && isLoggedIn && hasJWT) ? userType === pmsConstants.USER_TYPE_PRACTICE_STRING ? <Navigate replace to={PmsUrlConfig.WELCOME_URL} /> :
            userType === pmsConstants.USER_TYPE_STAFF ? <Navigate replace to={PmsUrlConfig.APPOINTMENTS} /> :
              <Navigate replace to={PmsUrlConfig.WELCOME_URL} />
            : <div className="col-12 main-div"><VerifyCode /></div>}
          errorElement={<ErrorPage />}
        />

        {/* Protected Routes */}
        <Route
          exact
            path={PmsUrlConfig.WELCOME_URL}
            element={(hydrated && isLoggedIn && hasJWT) ? userType === pmsConstants.USER_TYPE_PRACTICE_STRING ? <UserManagement /> :
            userType === pmsConstants.USER_TYPE_STAFF ? <Navigate replace to={PmsUrlConfig.APPOINTMENTS} /> :
              <PatientDashboardPage />
            : <Navigate replace to={PmsUrlConfig.HOME_URL} />
          }
        />
        <Route
          exact
          path={PmsUrlConfig.APPOINTMENTS}
          element={(hydrated && isLoggedIn && hasJWT) ? userType === pmsConstants.USER_TYPE_PRACTICE_STRING ? <StaffAppointmentsPage /> :
            userType === pmsConstants.USER_TYPE_STAFF ? <StaffAppointmentsPage /> :
              <PatientAppointmentsPage />
            : <Navigate replace to={PmsUrlConfig.HOME_URL} />
          }
        />
        <Route
          exact
          path={PmsUrlConfig.CHATS}
          element={(hydrated && isLoggedIn && hasJWT) ? userType === pmsConstants.USER_TYPE_PRACTICE_STRING ? <StaffChatsPage /> :
            userType === pmsConstants.USER_TYPE_STAFF ? <StaffChatsPage /> :
              <PatientChatsPage />
            : <Navigate replace to={PmsUrlConfig.HOME_URL} />
          }
        />
        <Route
          exact
          path={PmsUrlConfig.VIEW_USERS}
          element={(hydrated && isLoggedIn && hasJWT) ? userType === pmsConstants.USER_TYPE_PRACTICE_STRING ? <UserManagement />
            : <Navigate replace to={PmsUrlConfig.HOME_URL} />
            : <Navigate replace to={PmsUrlConfig.HOME_URL} />
          }
        />
        <Route
          exact
          path={PmsUrlConfig.VIEW_SERVICE_LOCATIONS}
          element={(hydrated && isLoggedIn && hasJWT) ? userType === pmsConstants.USER_TYPE_PRACTICE_STRING ? <ServiceLocations />
            : <Navigate replace to={PmsUrlConfig.HOME_URL} />
            : <Navigate replace to={PmsUrlConfig.HOME_URL} />
          }
        />
        <Route
          exact
          path={PmsUrlConfig.SETTINGS}
          element={(hydrated && isLoggedIn && hasJWT) ? <SettingsPage />
            : <Navigate replace to={PmsUrlConfig.HOME_URL} />
          }
        />
        <Route
          exact
          path={PmsUrlConfig.CHANGE_PASSWORD_URL}
          element={(hydrated && hasJWT) ? <div className="col-12 main-div"><ChangePassword /></div>
            : <Navigate replace to={PmsUrlConfig.HOME_URL} />}
          errorElement={<ErrorPage />}
        />
      </Routes>
    </Router>
  );
}
